import {Grid} from '@mui/material';

import {CompanyAdmins} from '../CompanyAdmins/CompanyAdmins';

import {CompanyModulesTable} from '../../../../../../features/company/settings/CompanyModulesTable';
import {TwoFactorAuthentication} from '../../../../../../features/company/settings/TwoFactorAuthentication';

export const CompanySettingsTab = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <CompanyModulesTable />
      </Grid>
      <Grid item xs={12}>
        <CompanyAdmins />
      </Grid>
      <Grid item xs={12} marginBottom={4}>
        <TwoFactorAuthentication />
      </Grid>
    </Grid>
  );
};
